import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewSession from './pages/NewSession';
import Strains from './pages/Strains';
import Brands from './pages/Brands';
import Products from './pages/Products';
import Compare from './pages/Compare';
import EditSession from './pages/EditSession';
import Settings from './pages/Settings';

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/new-session" element={<NewSession />} />
                    <Route path="/strains" element={<Strains />} />
                    <Route path="/brands" element={<Brands />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/compare" element={<Compare />} />
                    <Route path="/edit-session/:id" element={<EditSession />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
